declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

// closed union so a typo fails typecheck instead of becoming a silent gap in the data
export type AnalyticsEvent =
  | 'click_to_call'
  | 'click_to_email'
  | 'click_to_maps'
  | 'contact_form_submit'
  | 'contact_form_success'
  | 'contact_form_error'
  | 'contact_form_blocked'
  | 'map_consent_granted'
  | 'cookie_consent'
  | 'web_vitals'

export type LinkLocation = 'header' | 'footer' | 'contact-page' | 'map-overlay'

type EventParams = Record<string, string | number | boolean | undefined>

// pushes only; gtm and consent mode decide whether anything is sent
export const pushEvent = (event: AnalyticsEvent, params: EventParams = {}): void => {
  if (typeof window === 'undefined') return

  // an event can fire before the gtm snippet runs, so the array must exist
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}
